import PropTypes from 'prop-types';
import styles from 'styles/LeadForm.module.scss';

const TextInput = ({ fieldName, setValue, placeholder = '', value = '' }) => {
    function onChange (e) {
        setValue(e.target.value);
    }

    if (value === null) {
        return null;
    }

    return (
        <div
            className={`
            ${styles.text_input__wrapper} ${styles[`text_input_${fieldName}`]}
            `}
        >
            <input
                type="text"
                placeholder={placeholder}
                name={fieldName}
                defaultValue={value}
                onChange={onChange}
            />
        </div>
    );
};

TextInput.propTypes = {
    fieldName: PropTypes.string.isRequired,
    placeholder: PropTypes.string,
    setValue: PropTypes.func.isRequired,
    value: PropTypes.string.isRequired
};

export default TextInput;
